import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { StatusCardComponent } from "@shared/components/status-card/status-card.component";
import { REGULARISATION_ON } from "@shared/constants/route.constants";
import { ReceiptStates } from "@shared/enums/receipt-states.enum";
import { PolicyReceiptsYearVm } from "@shared/models/policy-receipts.model";
import { StatusConfig } from "@shared/models/status-config.model";
import { ReceiptStateService } from "@shared/services/receipt-state.service";
import { Guid } from "guid-typescript";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "app-receipts-detail-info",
  standalone: true,
  imports: [StatusCardComponent, ButtonModule, TranslateModule, CommonModule],
  templateUrl: "./receipts-detail-info.component.html",
})
export class ReceiptsDetailInfoComponent implements OnInit {
  @Input() policyId!: Guid;
  @Input() paymentSchedule: PolicyReceiptsYearVm[] = [];
  @Input() needPayment = false;
  receiptStatusConfig!: Record<string, StatusConfig>;
  ReceiptStates = ReceiptStates;
  constructor(
    private readonly router: Router,
    private readonly receiptStateService: ReceiptStateService
  ) {}
  ngOnInit(): void {
    this.receiptStatusConfig = this.receiptStateService.getReceiptStateConfig();
  }

  getStatusClass(status: string): string {
    return this.receiptStateService.getStatusClass(status);
  }

  onReceiptClick(status: string): void {
    if (status === ReceiptStates.IMP) {
      this.paymentNavigation();
    }
  }

  paymentNavigation(): void {
    this.router.navigate([REGULARISATION_ON], {
      queryParams: { policy: this.policyId },
    });
  }
}
